<template>
  <div class="check-work-body">

    <!-- 搜索 -->
    <div class="search-wrap">
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getList()" :loading="searchLoading">搜索</el-button>
    </div>

    <div class="check-work-class-editor">
      <div class="cw-header">
        <div class="cw-title cw-name">姓名</div>
        <div class="cw-title cw-class">排班</div>
      </div>
    </div>

  </div>
</template>

<script>

  import { Admin } from './common.js'

export default {
  name: "check-work-admin",
  data() {
    return{
      keyword: '',
      searchLoading: false,
      date: new Date()
    }
  },
  mounted() {


  },
  methods:{


    // end methods
  }
}
</script>

<style lang="scss" scoped>
  @import './common.scss';


</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/CheckWorkUserClass.vue